var configs = require("../../public/config.json");

const getCalculateCheckoutTotal = (
  subTotal,
  promo,
  pointsAmount,
  deliveryFee,
  total,
  smallAmountFee
) => {
  let calculatedTotal = 0,
    localPointDiscount = 0;
  if (total) {
    let promoAmount;
    if (promo.type === "FREE_DELIVERY") {
      if (deliveryFee) {
        promoAmount = parseFloat(deliveryFee);
      }
    } else if (promo.type === "PERCENT") {
      promoAmount = parseFloat(
        (parseFloat(subTotal) * parseFloat(promo.amount)) / 100
      );
    } else {
      promoAmount = promo.amount || 0;
    }
    const totalWithPromotion = parseFloat(
      parseFloat(total) - parseFloat(promoAmount)
    );
    localPointDiscount = parseFloat(pointsAmount) * configs.ptsToGbp;

    if (localPointDiscount > parseFloat(totalWithPromotion)) {
      localPointDiscount = parseFloat(totalWithPromotion);
    }

    calculatedTotal = parseFloat(
      totalWithPromotion - localPointDiscount
    ).toFixed(2);
  }

  return {
    calculatedTotal,
    localPointDiscount
  };
};

export default getCalculateCheckoutTotal;
